<template>
  <v-app light>
    <v-slide-x-transition mode="out-in">
      <router-view v-if="!loading" />
      <v-container v-else class="page-loader" fluid fill-height>
        <v-layout justify-center align-center class="text-xs-center">
          <div class="animate logo d-flex align-center justify-center pa-1 mr-1" style="border-radius: 100%; height: 80px">
            <img src="/static/logo-name.png" class="fill-width fill-height">
          </div>
          <div class="animate loader d-flex justify-center align-center">
            <v-progress-circular indeterminate :size="35" :width="3" color="primary"></v-progress-circular>
          </div>
        </v-layout>
      </v-container>
    </v-slide-x-transition>
  </v-app>
</template>

<script>
  import appState from './store/app'

  export default {
    data () {
      return appState
    }
  }
</script>

<style lang="scss">
@import '@/plugins/vuetify.scss';
</style>

<style lang="scss" scoped>
  .page-loader {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .animate {
    animation-duration: .5s;
    animation-fill-mode: backwards;
  }
  .logo {
    animation-name: logo;
    animation-delay: .1s;
  }
  .loader {
    animation-name: loader;
    animation-delay: .4s;
  }
  @keyframes logo {
    from { transform: translateX(25px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  @keyframes loader {
    from { transform: translateX(-25px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
</style>

